'use client';

import qs from 'query-string';
import { FC, useEffect, useState } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { IconFacebook } from 'src/general/Icons/IconFacebook';
import { Button } from 'src/general/components/Button/Button';
import { getMicrocopy } from 'src/stores/microcopyStore';

import { SSOProps } from './SSO.types';
import { getSigninUrl } from './ssoHelper';

const carmaAuthApi = `${process.env.REACT_APP_AUTH_BASE_API_URL}/auth/facebook`;

export const SSOFacebook: FC<SSOProps> = ({ redirectUrl }) => {
  const label = getMicrocopy(MICROCOPY.AUTHENTICATION_SIGNUP_LOGIN_FACEBOOK_LABEL);
  const icon = <IconFacebook />;
  const [ssoUrl, setSsoUrl] = useState<string | null>(null);

  useEffect(() => {
    const signinUrl = getSigninUrl(redirectUrl);
    const queryParams = qs.stringify({
      client_id: process.env.REACT_APP_FACEBOOK_AUTH_CLIENT_ID,
      redirect_uri: carmaAuthApi,
      state: btoa(signinUrl),
      scope: 'email',
    });

    setSsoUrl(`https://www.facebook.com/v18.0/dialog/oauth?${queryParams}`);
  }, [redirectUrl]);

  if (!ssoUrl) {
    return null;
  }

  return (
    <Button startIcon={icon} href={ssoUrl} target="_self" fullWidth variant="secondary" size="medium">
      {label}
    </Button>
  );
};
